import { useContext } from "react";
import { TranslationContext } from "../../../context/translations/translations-context";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../../hooks/useResumeProperties";
import { calculateTotalExperienceDuration } from "../../../utils/calculateDatesDifference";
import BusinessSkillsPreview from './BusinessSkillsPreview';
import DiplomasPreview from './DiplomasPreview';
import ExperiencesPreview from './ExperiencesPreview';
import HobbiesPreview from './HobbiesPreview';
import LanguagesSkillsPreview from './LanguagesSkillsPreview';

export default function MainContent() {

    const { translations } = useContext( TranslationContext );
    const { isEuropass, isAlcyone, isExperienceHidden } = useResumeProperties();
    const { introduction, totalExperienceDuration, experiences } = useResumeDocumentSection();

    const {
        years: experienceYears,
        months: experienceMonths,
    } = calculateTotalExperienceDuration( experiences, totalExperienceDuration );

    return (
        <main className="px-5 content-block">
            <div className="card-body">
                { !isEuropass && isExperienceHidden && (
                    <p className="text-end" style={ { fontSize: "11px" } }>
                        { translations.pdf.workExperienceLabel }{ ' ' }
                        { translations.pdf.workExperienceTemplate
                            .replace( "{years}", experienceYears )
                            .replace( "{months}", experienceMonths ) }
                    </p>
                ) }
                { !isEuropass ? (
                    <p
                        className="card-subtitle text-black"
                        id="job-title-preview"
                        style={ {
                            fontSize: "12px",
                            whiteSpace: "pre-line",
                            textAlign: "justify",
                            wordBreak: "break-word",
                            overflowWrap: "anywhere"
                        } }
                    >
                        { introduction }
                    </p>
                ) : (
                    <>
                        <p
                            className={ `${ isAlcyone ? "fw-bold subtitre-cv pt-3" : "fw-bold subtitre-lusis-cv pt-3" }` }
                            id="skills-preview"
                            style={ {
                                fontSize: isEuropass ? "11px" : "12px",
                                marginBottom: "0px",
                                color: isEuropass && "#000000"
                            } }
                        >
                            <ul style={ { margin: "0px", padding: "0px" } }>
                                <li>{ translations.pdf.introductionLabel }</li>
                            </ul>
                        </p>
                        <hr style={ {
                            color: "#979797",
                            height: "2px",
                            width: "100%",
                            marginLeft: "0px",
                            marginBottom: "20px",
                            marginTop: "4px"
                        } }/>
                        <p
                            className="card-subtitle text-black"
                            id="job-title-preview"
                            style={ {
                                fontSize: "12px",
                                whiteSpace: "pre-line",
                                textAlign: "justify",
                                wordBreak: "break-word",
                                overflowWrap: "anywhere"
                            } }
                        >
                            { introduction }
                        </p>
                    </>
                ) }
                {/* Language Skills */ }
                { !isEuropass && (
                    <>
                        <div className="subtitre-cv-container d-flex align-items-center gap-3">
                            <p
                                id="skills-preview"
                                className={ `${ isAlcyone ? "fw-bold subtitre-cv pt-3"
                                    : "fw-bold subtitre-lusis-cv pt-3" }` }
                                style={ { fontSize: isEuropass ? "11px" : "12px" } }
                            >
                                <span>{ translations.pdf.languageSkillsShortTitle }</span>
                            </p>
                            <div className={ `${ isAlcyone ? "line" : "line-lusis" }` }></div>
                        </div>
                        <LanguagesSkillsPreview/>
                    </>
                ) }

                {/* Business Skills */ }
                { !isEuropass && (
                    <>
                        <div className="subtitre-cv-container d-flex align-items-center gap-3"
                             style={ { marginTop: "-15px" } }>
                            <p
                                className={ `${ isAlcyone ? "fw-bold subtitre-cv pt-3"
                                    : "fw-bold subtitre-lusis-cv pt-3" }` }
                                id="skills-preview"
                                style={ { fontSize: "12px" } }
                            >
                                { translations?.pdf.businessSkillsTitle }
                            </p>
                            <div className={ `${ isAlcyone ? "line" : "line-lusis" }` }></div>
                        </div>
                        <BusinessSkillsPreview/>
                    </>
                ) }

                {/* Experiences */ }
                { !isExperienceHidden && (
                    <>
                        <div className="subtitre-cv-container d-flex align-items-center gap-3 avoid-page-break-before">
                            <p
                                className={ `${ isAlcyone ? "fw-bold subtitre-cv pt-3" : "fw-bold subtitre-lusis-cv pt-3" }` }
                                id="skills-preview"
                                style={ {
                                    fontSize: isEuropass ? "11px" : "12px",
                                    marginBottom: "0px",
                                    color: isEuropass && "#000000"
                                } }
                            >
                                { isEuropass ? (
                                    <ul style={ { margin: "0px", padding: "0px" } }>
                                        <li>{ translations.pdf.experiencesTitle }</li>
                                    </ul>
                                ) : (
                                    <span>{ translations.pdf.experiencesShortTitle }</span>
                                ) }
                            </p>
                            { !isEuropass && (
                                <div className={ `${ isAlcyone ? "line" : "line-lusis" }` }></div>
                            ) }
                        </div>
                        { isEuropass && (
                            <hr style={ {
                                color: "#979797",
                                height: "2px",
                                width: "100%",
                                marginLeft: "0px",
                                marginBottom: "0px",
                                marginTop: "4px"
                            } }/>
                        ) }
                        <ExperiencesPreview/>
                    </>
                ) }

                {/* Formations */ }
                <div className="subtitre-cv-container d-flex align-items-center gap-3"
                     style={ { pageBreakInside: 'avoid' } }>
                    <p
                        className={ `${ isAlcyone ? "fw-bold subtitre-cv pt-3" : "fw-bold subtitre-lusis-cv pt-3" }` }
                        id="skills-preview"
                        style={ {
                            fontSize: isEuropass ? "11px" : "12px",
                            marginBottom: "0px",
                            color: isEuropass && "#000000"
                        } }
                    >
                        { isEuropass ? (
                            <ul style={ { margin: "0px", padding: "0px" } }>
                                <li>{ translations.pdf.diplomasTitle }</li>
                            </ul>
                        ) : (
                            <span>{ translations.pdf.diplomasShortTitle }</span>
                        ) }
                    </p>
                    { !isEuropass && (
                        <div className={ `${ isAlcyone ? "line" : "line-lusis" }` }></div>
                    ) }
                </div>
                { isEuropass && (
                    <hr style={ {
                        color: "#979797",
                        height: "2px",
                        width: "100%",
                        marginLeft: "0px",
                        marginBottom: "20px",
                        marginTop: "4px"
                    } }/>
                ) }
                <DiplomasPreview/>

                { isEuropass && (
                    <div className="subtitre-cv-container d-flex align-items-center gap-3">
                        <p
                            className={ `${ isAlcyone ? "fw-bold subtitre-cv pt-3" : "fw-bold subtitre-lusis-cv pt-3" }` }
                            id="skills-preview"
                            style={ {
                                fontSize: isEuropass ? "11px" : "12px",
                                marginBottom: "0px",
                                color: isEuropass && "#000000"
                            } }
                        >
                            <ul style={ { margin: "0px", padding: "0px" } }>
                                <li>{ translations.pdf.languageSkillsTitle }</li>
                            </ul>
                        </p>
                    </div>
                ) }

                { isEuropass && (
                    <hr style={ {
                        color: "#979797",
                        height: "2px",
                        width: "100%",
                        marginLeft: "0px",
                        marginBottom: "20px",
                        marginTop: "4px"
                    } }/>
                ) }

                { isEuropass && ( <LanguagesSkillsPreview/> ) }

                { isEuropass && (
                    <>
                        <div className="subtitre-cv-container d-flex align-items-center gap-3"
                             style={ { marginTop: "-15px" } }>
                            <p
                                className={ `${ isAlcyone ? "fw-bold subtitre-cv pt-3"
                                    : "fw-bold subtitre-lusis-cv pt-3" }` }
                                id="skills-preview"
                                style={ {
                                    fontSize: isEuropass ? "11px" : "12px",
                                    marginBottom: "0px",
                                    color: isEuropass && "#000000"
                                } }
                            >
                                <ul style={ { margin: "0px", padding: "0px" } }>
                                    <li>{ translations.pdf.businessSkillsTitle }</li>
                                </ul>
                            </p>
                        </div>
                        <hr style={ {
                            color: "#979797",
                            height: "2px",
                            width: "100%",
                            marginLeft: "0px",
                            marginBottom: "20px",
                            marginTop: "4px"
                        } }/>
                        <BusinessSkillsPreview/>
                    </>
                ) }

                {/* Loisirs */ }
                <div className="subtitre-cv-container d-flex align-items-center gap-3 no-page-break">
                    { !isEuropass ? (
                        <p
                            className={ `${ isAlcyone ? "fw-bold subtitre-cv pt-3" : "fw-bold subtitre-lusis-cv pt-3" }` }
                            id="skills-preview"
                            style={ { fontSize: "12px" } }
                        >
                            { translations.pdf.hobbiesTitle }
                        </p>
                    ) : (
                        <p
                            className={ `${ isAlcyone ? "fw-bold subtitre-cv pt-3" : "fw-bold subtitre-lusis-cv pt-3" }` }
                            id="skills-preview"
                            style={ {
                                fontSize: isEuropass ? "11px" : "12px",
                                marginBottom: "0px",
                                color: isEuropass && "#000000"
                            } }
                        >
                            { isEuropass && (
                                <ul style={ { margin: "0px", padding: "0px" } }>
                                    <li>{ translations.pdf.hobbiesTitle }</li>
                                </ul>
                            ) }
                        </p>
                    ) }

                    { !isEuropass && (
                        <div className={ `${ isAlcyone ? "line" : "line-lusis" }` }></div>
                    ) }
                </div>
                { isEuropass && (
                    <hr style={ {
                        color: "#979797",
                        height: "2px",
                        width: "100%",
                        marginLeft: "0px",
                        marginBottom: "20px",
                        marginTop: "4px"
                    } }/>
                ) }
                <HobbiesPreview/>
            </div>
        </main>
    );
}
